export default __webpack_public_path__ + "static/bg-price-e639662ce6bcd2b3699e87f552f7c64d.png";